import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './permission'
import elementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import videoPlayer from 'vue-video-player'
import "video.js/dist/video-js.css";
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(videoPlayer)
Vue.use(VueQuillEditor)
Vue.config.productionTip = false
Vue.use(elementUI)

//EventBus事件中转
Vue.prototype.$bus = new Vue()  

//图片兜底：OSS 图片加载失败时自动回退到服务器地址
window.addEventListener('error', function (e) {
  var t = e.target
  var base = 'https://ape-learn-imgs.oss-cn-hangzhou.aliyuncs.com'
  if (t && t.tagName === 'IMG' && t.src && t.src.indexOf(base) > -1) {
    if (t.src.indexOf(base + '/image/') > -1) {
      // 页面装饰素材：回退到站点本地路径（/image/...）
      t.src = t.src.replace(base, '')
    } else {
      // 内容图片：回退到接口路径（/api/img/...）
      t.src = t.src.replace(base, '/api')
    }
  }
}, true)  

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
